import styled from 'styled-components';

const Heading = styled.h3`
	letter-spacing: 0.2px;
	line-height: 20px;
	font-size: 19px;
	font-weight: 600;
`;

export default Heading;
